import { render, staticRenderFns } from "./CommonTable2.vue?vue&type=template&id=074419f2&scoped=true&"
import script from "./CommonTable2.vue?vue&type=script&lang=js&"
export * from "./CommonTable2.vue?vue&type=script&lang=js&"
import style0 from "./CommonTable2.vue?vue&type=style&index=0&id=074419f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074419f2",
  null
  
)

export default component.exports